import React from 'react';
import { CInput, CInputGroup, CInputGroupPrepend, CInputGroupText } from '@coreui/react';
import CIcon from '@coreui/icons-react';

interface ContactSearchProps {
  onQueryChange: (value) => void;
  searchQuery: string;
}

const ContactSearch = (props: ContactSearchProps) => {
  const {
    onQueryChange,
    searchQuery
  } = props;


  return (
    <div className="d-flex p-2 align-items-center chat-search-container">
      <CInputGroup style={{ borderRadius: '20px', overflow: 'hidden', border: '1px solid #d8dbe0' }}>
        <CInputGroupPrepend>
          <CInputGroupText style={{ backgroundColor: 'white', border: 'none' }}>
            <CIcon name="cil-zoom-in" />
          </CInputGroupText>
        </CInputGroupPrepend>
        <CInput
          className="chat-search-input"
          type="search"
          id="chat-search"
          name="chat-search"
          placeholder="Search"
          value={searchQuery}
          onChange={onQueryChange}
          style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
        />
      </CInputGroup>
    </div>
  )
};

export default ContactSearch;
